import { observer } from "mobx-react";
import React from "react";
import { ProgressBar } from "~/components/V2/ProgressBar";
import { View } from "~/components/V2/View";
import { useStore } from "~/mobx/utils/useStore";
import { shadow } from "~/utils/shadow";
import type { PropsWithChildren } from "react";

interface StepTopNavProps {
  shouldAnimateProgressBar: boolean;
}

export const StepTopNav = observer(function StepTopNav({
  shouldAnimateProgressBar,
  children,
}: PropsWithChildren<StepTopNavProps>) {
  const store = useStore();

  const showHeader = store.bookingStore.showHeader;

  return (
    <>
      <ProgressBar shouldAnimateProgressBar={shouldAnimateProgressBar} />
      <>
        {showHeader && (
          <View
            padding16
            flexDirectionRow
            alignItemsCenter
            colorWhite
            style={{
              ...shadow(4),
              zIndex: 10,
              // override web shadow
              boxShadow: `0px 1px 7px rgba(51, 51, 51, 0.1)`,
            }}
          >
            {children}
          </View>
        )}
      </>
    </>
  );
});
